// پارسه — balance, price list, top-up, gift codes, the ledger.
export const credits = {
  // ── پارسه — the wallet ───────────────────────────────────────────────
  'credits.title': 'Parseh',
  'credits.sub': 'Parsina’s credit for the assistant. Every answer spends some.',
  'credits.balance.label': 'Your balance',
  'credits.balance.loading': 'Reading your balance…',
  'credits.free.title': '500 Parseh, free, every month',
  'credits.free.body': 'Renewed at the start of each month whether you top up or not.',
  'credits.priceList.title': 'What each action costs',
  'credits.price.ask': 'Ask the assistant',
  'credits.price.differential': 'Differential diagnosis',
  'credits.price.soap': 'SOAP suggestion',
  'credits.price.orders': 'Order suggestions',
  'credits.price.interaction': 'Drug interaction check',
  'credits.price.voice': 'Voice intake',
  'credits.topUp.title': 'Top up',
  'credits.topUp.action': 'Buy Parseh',
  'credits.topUp.recommended': 'Recommended',
  'credits.topUp.custom': 'Another amount',
  'credits.topUp.customLabel': 'Amount in Toman',
  'credits.topUp.pay': 'Pay {{amount}} Toman via {{gateway}}',
  'credits.topUp.redirecting': 'Taking you to the bank…',
  'credits.topUp.min': 'The smallest purchase is {{amount}} Toman.',
  'credits.topUp.note': 'You will be taken to the bank’s own page to pay.',
  'credits.topUp.failed': 'Could not start the payment.',
  'credits.gateway.saderat': 'Saderat / Sepehr',
  'credits.gateway.zarinpal': 'Zarinpal',
  'credits.gift.title': 'Gift code',
  'credits.gift.hint': 'Have a code from a Parsina campaign? Redeem it here.',
  'credits.gift.placeholder': 'PARSINA-XXXX',
  'credits.gift.submit': 'Redeem',
  'credits.gift.submitting': 'Redeeming…',
  'credits.gift.empty': 'Enter a code first.',
  'credits.gift.notFound': 'That code is not valid.',
  'credits.gift.success': '{{parseh}} Parseh added.',
  'credits.gift.newBalance': 'New balance',
  'credits.gift.oneUse': 'A code can be used once.',
  'credits.gift.myCodes': 'Codes you have used',
  'credits.gift.worth': 'Worth {{parseh}} Parseh',
  'credits.gift.status.issued': 'Unused',
  'credits.gift.status.redeemed': 'Used',
  'credits.gift.status.revoked': 'Revoked',
  'credits.gift.status.expired': 'Expired',
  'credits.tx.title': 'Transactions',
  'credits.tx.empty.title': 'Nothing yet',
  'credits.tx.empty.body': 'Your spending and top-ups will appear here.',
  'credits.tx.error.title': 'Could not load the transactions',
  'credits.tx.columns.date': 'When',
  'credits.tx.columns.service': 'What for',
  'credits.tx.columns.description': 'Detail',
  'credits.tx.columns.amount': 'Parseh',
  'credits.tx.filter.all': 'All',
  'credits.tx.filter.credit': 'Added',
  'credits.tx.filter.debit': 'Spent',
  'credits.service.ask': 'Assistant question',
  'credits.service.differential': 'Differential diagnosis',
  'credits.service.interaction': 'Interaction check',
  'credits.service.transcription': 'Transcription',
  'credits.service.gift': 'Gift code',
  'credits.service.topup': 'Top-up',
  'credits.service.sms': 'SMS',
  'credits.service.other': 'Smart feature',
};

export default credits;
